import React from 'react'
import clsx from 'clsx'
import {AccordionContext} from './AccordionContext'

const Accordion = ({className, children: childrenProp, onChange}) => {
  const [expanded, setExpandedState] = React.useState(false)
  const handleChange = React.useCallback(
    event => {
      setExpandedState(!expanded)

      if (onChange) {
        onChange(event, !expanded)
      }
    },
    [expanded, onChange, setExpandedState],
  )

  const [summary, ...children] = React.Children.toArray(childrenProp)

  const contextValue = React.useMemo(() => ({expanded, toggle: handleChange}), [
    expanded,
    handleChange,
  ])

  const styles = clsx(
    'pt-4 mt-5',
    expanded && 'block',
    !expanded && 'hidden',
    className,
  )

  return (
    <div className={clsx('shadow-lg p-3.5 mt-8', className)}>
      <AccordionContext.Provider value={contextValue}>
        {summary}
      </AccordionContext.Provider>
      <div className={styles} style={{borderTop: '1px solid #bdbdbd'}}>
        {children}
      </div>
    </div>
  )
}

export {Accordion}
